import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private url: string = environment.apiUrl;
  constructor(private http: HttpClient) {}
  ForgotPassword(email): Observable<object> {
    return this.http.post<object>(`${this.url}Account/ForgotPassword`, email);
  }
  ResetPassword(password: string, userId: string, code: string): Observable<object> {
    return this.http.post<object>(`${this.url}Account/ResetPassword`, { password, userId, code });
  }
}
